<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <dashboard-gerencial :loading="loading" :execucao="execucao" @download-resultado="baixarResultado" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AgingService from '@/services/AgingService';

  export default {
    name: 'PainelGerencialAging',

    components: {
      DashboardGerencial: () => import('@/components/aging/DashboardGerencial.vue')
    },

    data() {
      return {
        loading: true,
        execucao: null
      };
    },

    created() {
      this.getDados();
    },

    methods: {
      getDados() {
        this.loading = true;
        AgingService.getDadosPainel(this.$route.params.id)
          .then((response) => {
            this.execucao = response.data.data;
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao carregar dados do painel gerencial.', '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },

      baixarResultado() {
        this.$toast.info('Preparando o arquivo resultado para download...', '', {
          position: 'topRight'
        });

        AgingService.download(this.$route.params.id)
          .then((res) => {
            const titulo = this.execucao?.titulo || this.$route.params.id;
            const nomeArquivo = `${titulo}.xlsx`;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeArquivo);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao baixar arquivo resultado.', '', {
              position: 'topRight'
            });
          });
      }
    }
  };
</script>
